import { SET_HOFLAGE } from "./mutations.type";
import { SET_BETRIEBSZWEIGE } from "./mutations.type";
import { SET_BEWIRTSCHAFTUNGSARTEN } from "./mutations.type";
import { SET_TIERE } from "./mutations.type";
import { SET_NEBENBETRIEBE } from "./mutations.type";
import { SET_EINSATZHERKUNFT_JUGENDLICHE } from "./mutations.type";
import { SET_AUSWAHL_EINSATZBEREICH } from "./mutations.type";
import { SET_SANITAEREINRICHTUNGEN } from "./mutations.type";
import { SET_VOUCHERSTATUS } from "./mutations.type";
import { LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA } from "./actions.type";

import AppApi from "@/api/AppApi";

export default {
  namespaced: true,
  state: {
    hoflage: [],
    betriebszweige: [],
    bewirtschaftungsarten: [],
    tiere: [],
    nebenbetriebe: [],
    einsatzherkunftJugendliche: [],
    auswahlEinsatzbereich: [],
    sanitaereinrichtungen: [],
    voucherStatus: [],
  },
  mutations: {
    [SET_HOFLAGE](state, val) {
      state.hoflage = val;
    },
    [SET_BETRIEBSZWEIGE](state, val) {
      state.betriebszweige = val;
    },
    [SET_BEWIRTSCHAFTUNGSARTEN](state, val) {
      state.bewirtschaftungsarten = val;
    },
    [SET_TIERE](state, val) {
      state.tiere = val;
    },
    [SET_NEBENBETRIEBE](state, val) {
      state.nebenbetriebe = val;
    },
    [SET_EINSATZHERKUNFT_JUGENDLICHE](state, val) {
      state.einsatzherkunftJugendliche = val;
    },
    [SET_AUSWAHL_EINSATZBEREICH](state, val) {
      state.auswahlEinsatzbereich = val;
    },
    [SET_SANITAEREINRICHTUNGEN](state, val) {
      state.sanitaereinrichtungen = val;
    },
    [SET_VOUCHERSTATUS](state, val) {
      state.voucherStatus = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA](context) {
      let response = await AppApi.get("auswahlwerte/agriviva-firma/");
      context.commit(SET_HOFLAGE, response.data.hoflage);
      context.commit(SET_BETRIEBSZWEIGE, response.data.betriebszweige);
      context.commit(
        SET_BEWIRTSCHAFTUNGSARTEN,
        response.data.bewirtschaftungsarten
      );
      context.commit(SET_TIERE, response.data.tiere);
      context.commit(SET_NEBENBETRIEBE, response.data.nebenbetriebe);
      context.commit(
        SET_EINSATZHERKUNFT_JUGENDLICHE,
        response.data.einsatzherkunftJugendliche
      );
      context.commit(
        SET_AUSWAHL_EINSATZBEREICH,
        response.data.auswahlEinsatzbereich
      );
      context.commit(
        SET_SANITAEREINRICHTUNGEN,
        response.data.sanitaereinrichtungen
      );
      context.commit(SET_VOUCHERSTATUS, response.data.voucherStatus);
    },
  }
};
